// @flow
/* eslint-disable react/no-danger */
import React, { useState, useRef } from 'react';
import type { Element } from 'react';
import CollapsibleContainer from '@justpark/ui/src/components/CollapsibleContainer';
import useLazyLoadIntersection from '../../hooks/useLazyLoadIntersection';
import { track } from '../../helpers/Tracking/Analytics';
import LandingInfoBoxes from './LandingInfoBoxes';

import '../../../static/scss/components/toggleLandingInfo.scss';

type Props = {
  toDisplay?: number,
  array: Array<Element<*>>,
  hideIcons: boolean
};

const ToggleLandingInfo = ({ toDisplay = 1, array, hideIcons }: Props) => {
  const [displayAll, toggle] = useState(false);
  const [ref, triggered] = useLazyLoadIntersection(100);
  const wrapperRef = useRef(null);

  const alwaysRendered = array.slice(0, toDisplay).join(' ');
  const variableRendered = array.slice(toDisplay, array.length).join(' ');

  if (!variableRendered) {
    return (
      <div className="c-toggleLandingInfo">
        <div
          className="c-toggleLandingInfo__content__always"
          dangerouslySetInnerHTML={{ __html: alwaysRendered }}
        />
        <LandingInfoBoxes
          hideIcons={hideIcons}
          triggered={triggered}
          displayAll={displayAll}
          reference={ref}
        />
      </div>
    );
  }

  if (wrapperRef.current) {
    const refHeight = wrapperRef.current.getBoundingClientRect().height;

    if (refHeight > 250 && refHeight < 365 && displayAll) {
      wrapperRef.current.style.height = '365px';
    }
  }

  return (
    <div className="c-toggleLandingInfo" ref={wrapperRef}>
      <div
        className="c-toggleLandingInfo__content__always"
        dangerouslySetInnerHTML={{ __html: alwaysRendered }}
      />

      <CollapsibleContainer isOpened={displayAll}>
        <div
          className={`c-toggleLandingInfo__content__variable ${
            displayAll ? 'c-toggleLandingInfo__content__variable--visible' : ''
          }`}
          dangerouslySetInnerHTML={{ __html: variableRendered }}
        />
      </CollapsibleContainer>
      <a
        className="c-toggleLandingInfo__toggle"
        onClick={() => {
          if (!displayAll) {
            track('click:additional-info:expand');
          }

          toggle(!displayAll);
        }}
      >
        Show {displayAll ? 'less' : 'more'}
      </a>
      <CollapsibleContainer isOpened={!displayAll}>
        <LandingInfoBoxes
          hideIcons={hideIcons}
          triggered={triggered}
          displayAll={displayAll}
          reference={ref}
        />
      </CollapsibleContainer>
    </div>
  );
};

export default ToggleLandingInfo;
